import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';

import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION, PB_DIRECTION, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { NgxUiLoaderService } from './ngx-ui-loader.service';
import { CoreModule } from './core/core.module';

import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  //suppressScrollX: true
  wheelPropagation: true
};

import {HeaderComponent} from './core/shared/components/header/header.component';
import {FooterComponent} from './core/shared/components/footer/footer.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#0072ba',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 100,
  fgsType: 'ball-scale-multiple',
  hasProgressBar: true,
  pbColor: '#0072ba',
  pbThickness: 5,
  pbDirection: PB_DIRECTION.leftToRight,
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.75)",
};
@NgModule({
  imports:      [
      BrowserAnimationsModule,
      RouterModule.forRoot(AppRoutes,{
        useHash: true
      }),
      HttpClientModule,
      NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
      NgxUiLoaderRouterModule,
      NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
      CoreModule,
      PerfectScrollbarModule
  ],
  declarations: [
      AppComponent,
      HeaderComponent,
      FooterComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  bootstrap:    [ AppComponent ]
})
export class AppModule { }
